const defaultState = () => ({
  account: null,
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setAccount(state, payload) {
      state.account = payload;
    },
    reset(state) {
      Object.assign(state, defaultState());
    },
  },
  actions: {
    async setAccount({ commit }, payload) {
      commit('setAccount', payload);
    },
  },
  getters: {
    account: state => state.account || {},
    accountId: (state, getters) => getters.account.id,
    isAccountActive: (state, getters, rootState, rootGetters) => rootGetters.developmentMode
      || Boolean(getters.account.payouts_enabled),
  },
};
